import React, { useState, useEffect, useContext } from "react";
import diamond from "../../../../assets/UFC_DC_V1/img/diamond.png";
import ssl from "../../../../assets/UFC_DC_V1/img/ssl.png";
import charterhouseclaims from "../../../../assets/MOCK_OD/img/charterhouseclaims.png";
import excellent_review from "../../../../assets/UFC_DC_V1/img/excellent-review.svg";
import pound from "../../../../assets/UFC_DC_V1/img/pound.png";
import bg_money_sml from "../../../../assets/UFC_DC_V1/img/bg-money-sml.png";
import logo_white from "../../../../assets/UFC_DC_V1/img/logo-white.png";
import GtmDataLayer from "../../../../Utility/GtmDataLayer";
import { useQuestionnaire } from "../../../../Hooks/useQuestionnaire";
import VisitorParamsContext from "../../../../Contexts/VisitorParams";
import { usePageLoad } from "../../../../Hooks/usePageLoad";
import { getPageName } from "../../../../Constants/PageNames";
import { useHistory } from "react-router-dom";
import { useAddressApi } from "../../../../Hooks/useAddressApi";

const Questions = () => {
  const query = new URLSearchParams(window.location.search);
  const [questOne, setQuestOne] = useState("hide");
  const [questTwo, setQuestTwo] = useState("show");
  const [showRefundSection, setShowRefundSection] = useState("");
  const [btnDisable, setBtnDisable] = useState(true);
  const [questThree, setQuestThree] = useState("hide");
  const [bacKbtnId, setBacKbtnId] = useState("1");
  const [estimatedRefund, setEstimatedRefund] = useState("");
  const [unaffordableRefund, setUnaffordableRefund] = useState("");
  const [question118, SetQuestion118] = useState("");
  const selectedBank = JSON.parse(localStorage.getItem("selectedBank")) || [];
  const { isLoading, SaveQuestionnaire } = useQuestionnaire();
  const { visitorParameters } = useContext(VisitorParamsContext);
  const formdata = JSON.parse(localStorage.getItem("formData"));
  const query_string = localStorage.getItem("queryString");
  const { savePageLoad, calledOnce } = usePageLoad();
  const splitName = localStorage.getItem("split_name");
  const uuid = visitorParameters.visitor_parameters.uuid;
  const history = useHistory();
  const { addressCheck } = useAddressApi();
  let nextPage = "questionaireUFC_DC_V4";

  useEffect(() => {
    if (!!uuid && !calledOnce) {
      const data = {
        uuid,
        page_name: getPageName("credit_check_question_mock_od"),
        status: "visited",
        source: "regular",
      };
      (async () => {
        await savePageLoad(
          visitorParameters.visitor_parameters,
          data,
          "visited_status",
          splitName,
          query_string,
          visitorParameters.data
        );
      })();
    }
  }, [uuid, calledOnce]);

  const completePageLeadStatus = () => {
    const data = {
      uuid,
      page_name: getPageName("credit_check_question_mock_od"),
      status: "completed",
      source: "regular",
    };
    (async () => {
      await savePageLoad(
        visitorParameters.visitor_parameters,
        data,
        "visited_status",
        splitName,
        query_string,
        visitorParameters.data
      );
    })();
  };

  let question_data = {};

  const storeQuestionnire = async (question_data) => {
    const response = await SaveQuestionnaire(
      visitorParameters.visitor_parameters,
      question_data,
      "question_store",
      visitorParameters.data,
      query_string,
      formdata
    );
  };
  let flage = false;

  const nextQuestion = (e) => {
    console.log("e.target.value", e.target.value);
    setEstimatedRefund(e.target.value);
    if (e.target.value) {
      GtmDataLayer({
        question: "free online scan",
      });
      flage = true;
      question_data = {
        question_id: 114,
        option_id: e.target.value,
        answer_text: null,
        input_answer: null,
      };
    }

    // if (e.target.value == "318") {
    //   setBacKbtnId(2);
    //   setQuestTwo("show");
    //   setQuestOne("hide");
    //   setBtnDisable(false);
    //   setShowRefundSection("hide");

    // } else
    //  if (e.target.value == "319") {
    // Redirect to the Questionaire page
    completePageLeadStatus();
    history.push(
      `/loader?uuid=${visitorParameters.visitor_parameters.uuid}&nextPage=${nextPage}`
    );
    // }

    if (flage) {
      storeQuestionnire(question_data);
      let _existingEntries = JSON.parse(localStorage.getItem("questionData"));
      if (_existingEntries == null) _existingEntries = [];
      let existingIndex = _existingEntries.findIndex(
        (entry) => entry.question_id === question_data.question_id
      );
      if (existingIndex !== -1) {
        _existingEntries.splice(existingIndex, 1);
      }
      _existingEntries.push(question_data);
      localStorage.setItem("questionData", JSON.stringify(_existingEntries));
    }
  };

  const prevQuestion = (e) => {
    const value = Number(e.target.value);
    console.log("value", value);
    setBacKbtnId((prevId) => {
      const newId = Math.max(1, prevId - 1); // Prevents going below 1

      setBtnDisable(newId === 1); // Disable only if backBtnId is 1

      return newId;
    });
    switch (value) {
      case 1:
        setBtnDisable(true);
        setShowRefundSection("");
        setQuestOne("show");
        setQuestTwo("hide");
        break;

      case 2:
        setBacKbtnId(1); // Moving back from 2 to 1
        setQuestThree("hide");
        setQuestTwo("show");
        setBtnDisable(false); // Re-enable button if it was disabled
        break;

      // case 3:
      //   setBtnDisable(true);
      //   setBacKbtnId(2); // Moving back from 3 to 2
      //   setQuestTwo("show");
      //   setQuestThree("hide"); // Assuming you meant "hide" instead of "three"
      //   break;

      default:
        console.warn("Unexpected value in prevQuestion:", value);
    }
  };

  const nextSlide = (e) => {
    setUnaffordableRefund(e.target.value);
    if (e.target.value) {
      GtmDataLayer({
        question: "other oppertunities",
      });
      flage = true;
      question_data = {
        question_id: 118,
        option_id: e.target.value,
        answer_text: null,
        input_answer: null,
      };
    }
    if (e.target.value == "326") {
      setBacKbtnId(2);
      setQuestTwo("hide");
      setQuestThree("show");
      setBtnDisable(false);
    } else if (e.target.value == "327") {
      if (estimatedRefund == "318") {
        addressCheck(visitorParameters.visitor_parameters, formdata);
      }
      completePageLeadStatus();
      history.push(
        `/loader?uuid=${visitorParameters.visitor_parameters.uuid}&nextPage=${nextPage}`
      );
    }

    if (flage) {
      storeQuestionnire(question_data);
      let _existingEntries = JSON.parse(localStorage.getItem("questionData"));
      if (_existingEntries == null) _existingEntries = [];
      let existingIndex = _existingEntries.findIndex(
        (entry) => entry.question_id === question_data.question_id
      );
      if (existingIndex !== -1) {
        _existingEntries.splice(existingIndex, 1);
      }
      _existingEntries.push(question_data);
      localStorage.setItem("questionData", JSON.stringify(_existingEntries));
    }
  };

  const nextBasicDetails = (e) => {
    SetQuestion118(e.target.value);
    if (e.target.value) {
      GtmDataLayer({
        question: "finance evaluation",
      });
      flage = true;
      question_data = {
        question_id: 115,
        option_id: e.target.value,
        answer_text: null,
        input_answer: null,
      };
      if (flage) {
        storeQuestionnire(question_data);
        let _existingEntries = JSON.parse(localStorage.getItem("questionData"));
        if (_existingEntries == null) _existingEntries = [];
        let existingIndex = _existingEntries.findIndex(
          (entry) => entry.question_id === question_data.question_id
        );
        if (existingIndex !== -1) {
          _existingEntries.splice(existingIndex, 1);
        }
        _existingEntries.push(question_data);
        localStorage.setItem("questionData", JSON.stringify(_existingEntries));
      }
      if (estimatedRefund == "318") {
        addressCheck(visitorParameters.visitor_parameters, formdata);
      }
      completePageLeadStatus();
      history.push(
        `/loader?uuid=${visitorParameters.visitor_parameters.uuid}&nextPage=${nextPage}`
      );
    }
  };
  return (
    <>
      <section className={`banner  parallax-container `}>
        <div className="d-lg-none d-md-none d-sm-block d-block money-bg-mobile">
          <img src={bg_money_sml} alt="" />
        </div>
        <div className="container">
          <div>
            <div className="brand">
              <div className="logo pt-3">
                <a href="index.html">
                  {" "}
                  <img src={logo_white} height="60" alt="" />
                </a>
              </div>
            </div>
          </div>
          <div></div>
        </div>
        <div className="container pt-5 px-lg-2 px-md-2 px-sm-0 px-0  ">
          <div className="inner-section   ">
            <div className="body-questionnaire mb-4">
              <div className="inner rounded-4">
                <div className="swiper qsSlider slide-up-now">
                  <div className="swiper-wrapper">
                    <div className={`swiper-slide slide-up-now ${questTwo}`}>
                      <h2 className="qs-title  ">
                        While reviewing your case, we’ve identified a potential
                        opportunity to pursue further claims for mis-sold car
                        finance.
                      </h2>
                      <p className="fs-16">
                        We believe our partner, Charterhouse Claims, is well
                        suited to support you with this claim for an opportunity
                        to earn £4,000 or more. If you would like, we may refer
                        your details to them.
                      </p>

                      <ul className="list-content mt-lg-0 mt-2 mb-0">
                        <li>This will not reduce your compensation</li>
                        <li>You are free to choose a different solicitor</li>
                        <li>
                          Charterhouse claim’s ability to act independently will
                          not be compromised
                        </li>
                        <li>We may receive a <u><span className="fw-semibold">referral-fee</span></u></li>
                      </ul>

                      <ul className="btn-option optinal-items  two-options  py-3   ">
                        <li>
                          <div className=" option_but " onClick={nextSlide}>
                            <input
                              type="radio"
                              id="326"
                              value="326"
                              name="check3"
                            />
                            <label
                              for="326"
                              className=" align-items-center endQuest"
                            >
                              <div> Yes, Please Pursue</div>
                            </label>
                          </div>
                        </li>

                        <li>
                          <div className="option_but" onClick={nextSlide}>
                            <input
                              type="radio"
                              id="327"
                              name="check3"
                              value="327"
                            />
                            <label for="327" className="endQuest">
                              <div> No, Thank You </div>
                            </label>
                          </div>
                        </li>
                      </ul>
                      <div className="d-flex justify-content-center ch_house_claims">
                        <img
                          src={charterhouseclaims}
                          alt="charterhouseclaims"
                        />
                      </div>
                      <p className="text-center p-14">
                        <a href="">View Charterhouse Claims Documents</a>
                      </p>
                    </div>
                    <div className={`swiper-slide slide-up-now ${questThree}`}>
                      <h2 className="qs-title  ">
                        You may be eligible for significantly more than just
                        overdraft-related refunds.
                      </h2>
                      <p className="fs-16">
                        If you regularly lived in your overdraft or couldn’t
                        maintain a positive bank balance, it’s very likely that
                        other financial products or charges during that time
                        were also unaffordable. We can check these for you — for
                        free.
                      </p>

                      <ul className="btn-option optinal-items  two-options    ">
                        <li>
                          <div
                            className=" option_but "
                            onClick={nextBasicDetails}
                          >
                            <input
                              type="radio"
                              id="320"
                              value="320"
                              name="check2"
                            />
                            <label
                              for="320"
                              className=" align-items-center endQuest"
                            >
                              <div> Yes, Please Pursue </div>
                            </label>
                          </div>
                        </li>

                        <li>
                          <div
                            className="option_but"
                            onClick={nextBasicDetails}
                          >
                            <input
                              type="radio"
                              id="321"
                              name="check2"
                              value="321"
                            />
                            <label for="321" className="endQuest">
                              <div> No, Thank You </div>
                            </label>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className=""></div>
                  <div className="mt-2 mb-4 text-center">
                    <div>
                      {" "}
                      <button
                        className="back-btn mainbckBtn bi bi-chevron-left"
                        type="button"
                        value={bacKbtnId}
                        onClick={prevQuestion}
                        disabled={btnDisable}
                      >
                        Back
                      </button>{" "}
                    </div>
                  </div>
                </div>

                <div className="mt-2 mb-3 justify-content-between  align-items-center text-center slide-up-now">
                  <div className="ms-auto d-flex justify-content-center g-2 pe-lg-3 pe-md-3 ps-sm-0 pe-0 mb-lg-0 mb-md-0 mb-sm-4  mb-4">
                    <div>
                      <img className="ps-2" height="28" src={ssl} alt="" />{" "}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="pt-lg-4 pt-md-5 pt-sm-3 pt-3">
              <div className="d-flex text-danger">
                <div className="pe-2"></div>
                <div>
                  <p className={` text-black ${questThree}`}>
                    This could include credit cards, payday loans, catalog
                    credit, or other charges that were approved while your
                    account was in a negative balance.{" "}
                    <strong>
                      Our clients average refund for each unaffordable credit is
                      £2,200*.{" "}
                    </strong>
                  </p>
                  {/* <p className={` text-black ${questThree}`}>
                    *Estimate based on £1,100 overcharge per finance agreement taken from the FCA's Motor Finance - Final Findings, multiplied by our average agreements per Client.

                  </p> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default Questions;
